<template>
  <div class="login">
    <img alt="Vue logo" src="../assets/logo.png">
  </div>
</template>

<script>

export default {
  name: 'login',
  components: {
  },
};
</script>
